import { FormControl } from '@angular/forms';

const validateCPF = (cpf) => {
  let sameDigits = 1;
  let i;

  if (cpf.length < 11) { return false; }
  for (i = 0; i < cpf.length - 1; i++) {
    if (cpf.charAt(i) !== cpf.charAt(i + 1)) {
      sameDigits = 0;
      break;
    }
  }

  if (!sameDigits) {
    const digits = cpf.substring(9);
    let numbers = cpf.substring(0, 9);
    let sum = 0;
    for (i = 10; i > 1; i--) { sum += numbers.charAt(10 - i) * i; }
    let result = sum % 11 < 2 ? 0 : 11 - sum % 11;
    if (result !== parseInt(digits.charAt(0), 10)) { return false; }
    numbers = cpf.substring(0, 10); sum = 0;
    for (i = 11; i > 1; i--) { sum += numbers.charAt(11 - i) * i; }
    result = sum % 11 < 2 ? 0 : 11 - sum % 11;
    return result === parseInt(digits.charAt(1), 10);
  } else {
    return false;
  }
};

export const cpfValidator = (control: FormControl): { [invalidCreditCard: string]: boolean } => {
  const cpfNumber = control.value.replace(/\D/g, '');
  const isValid = validateCPF(cpfNumber);

  if ((cpfNumber && cpfNumber !== '' && !isValid)) {
    return { invalidCPF: true };
  }
};
